import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import { Form, FormField } from "components/ui/form";
import { InputGs, SelectGs } from "components/ui/Forms";
import { Button } from "components/ui/ButtonGs";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { useErrorHandler } from "exceptions/ErrorHandler";
import { useCompany } from "hooks/api/options";
import { useHubChecklistUser } from 'hooks/api';
import { useHistory } from "react-router-dom";
import { toast } from "sonner";

import { formSchema } from "../../formSchema";

export const CreateForm: React.FC = () => {
  const navigate = useHistory();
  const queryClient = useQueryClient();
  const { errorHandler } = useErrorHandler();
  const { createChecklistUser } = useHubChecklistUser();
  const { getListCompany } = useCompany();

  const form = useForm<z.infer<typeof formSchema>>({
    resolver: zodResolver(formSchema),
    defaultValues: {},
  });

  const {
    data: optionsCompany,
    isLoading: isLoadingOptionsCompany,
    refetch: refetchOptionsCompany,
  } = useQuery({
    queryKey: ["getListCompany"],
    queryFn: () => getListCompany({ all: true, type: "CD", picking_manage: 1 }),
    enabled: false,
  });

  const mutation = useMutation(createChecklistUser, {
    onSuccess: () => {
      queryClient.invalidateQueries("createChecklistUser");
      navigate.push("/settings/hub-checklist-user");
      toast.success("Usuário criado com sucesso!");
    },
    onError: (error) => {
      errorHandler(error);
    },
  });

  const onSubmit = (data: z.infer<typeof formSchema>) => {
    mutation.mutate({
      ...data,
    });
  };
  useEffect(() => {
    if (!optionsCompany) {
      refetchOptionsCompany();
    }
  }, [refetchOptionsCompany, optionsCompany]);

  return (
    <div>
      <Form {...form}>
        <form onSubmit={form.handleSubmit(onSubmit)} className="flex flex-col">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
            <FormField
              name="name"
              control={form.control}
              render={({ field }) => <InputGs {...field} label="Nome" />}
            />

            <FormField
              name="email"
              control={form.control}
              render={({ field }) => (
                <InputGs {...field} value={field.value ?? ""} label="Email" />
              )}
            />

            <FormField
              name="password"
              control={form.control}
              render={({ field }) => (
                <InputGs {...field} label="Senha do APP" type="password" />
              )}
            />

            <FormField
              name="general_company_id"
              control={form.control}
              render={({ field }) => (
                <SelectGs
                  {...field}
                  label={"Centro"}
                  onValueChange={(value: string) => {
                    field.onChange(value);
                  }}
                  content={optionsCompany || []}
                  isLoading={isLoadingOptionsCompany}
                  value={field.value ?? undefined}
                  disabled={isLoadingOptionsCompany}
                />
              )}
            />
          </div>
          <div className="flex justify-end w-full gap-4">
            <Button.Root
              variant="secondary"
              size="sm"
              type="button"
              onClick={() => navigate.push("/settings/hub-checklist-user")}
            >
              Cancelar
            </Button.Root>
            <Button.Root
              variant="primary"
              size="sm"
              type="submit"
              disabled={mutation.isLoading}
            >
              Salvar
            </Button.Root>
          </div>
        </form>
      </Form>
    </div>
  );
};
